import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const BusinessCardSkeleton = React.memo(() => {
  return (
    <div className="card business-card">
      <div className="card-body">
        <div className="d-flex flex-row gap-2">
          <div className="d-flex justify-content-center align-items-center" style={{ width: "7.5rem" }}>
            <Skeleton circle height={60} width={60} />
          </div>
          <div className="d-flex flex-column flex-grow-1">
            <Skeleton height={18} width="70%" className="mb-1" />
            <Skeleton height={14} width="50%" className="mb-2" />
            <Skeleton height={20} width={80} />
          </div>
        </div>
      </div>
      <div className="card-footer bg-transparent border-1">
        <div className="card-footer-content d-flex justify-content-between align-items-center">
          <Skeleton height={16} width={60} />
          <Skeleton height={32} width={100} />
        </div>
      </div>
    </div>
  );
});

export default BusinessCardSkeleton;
